// import React, { useState, useEffect, useMemo } from 'react';
// import axios from 'axios';
// import { AgGridReact } from 'ag-grid-react';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
// import LoadingIndicator from '../utils/loading/LoadingIndicator';  // Adjust path as necessary
// import { useLoading } from '../utils/loading/LoadingContext';  // Adjust path as necessary

// const BiddingSheet = () => {
//     const [biddingSheet, setBiddingSheet] = useState(null);
//     const [manifestItems, setManifestItems] = useState([]);
//     const [timeRange, setTimeRange] = useState('current_month'); // Default to current month
//     const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
//     const [selectedTable, setSelectedTable] = useState("Manifest");
//     const { isLoading, setLoading } = useLoading();

//     useEffect(() => {
//         setLoading(true); // Start loading

//         // Fetch all bidding sheets and select the latest one based on identifier
//         axios.get(`${baseUrl}/api/bidding-sheets/?table=${selectedTable}`)
//             .then(response => {
//                 const allBiddingSheets = response.data;

//                 // Sort by identifier in descending order (latest first)
//                 allBiddingSheets.sort((a, b) => {
//                     return b.identifier.localeCompare(a.identifier, undefined, { numeric: true });
//                 });

//                 // Set the latest bidding sheet
//                 if (allBiddingSheets.length > 0) {
//                     setBiddingSheet(allBiddingSheets[0]);
//                 }
//                 setLoading(false); // End loading
//             })
//             .catch(error => {
//                 console.error('There was an error fetching the bidding sheets data!', error);
//                 setLoading(false); // End loading even on error
//             });

//         fetchManifestData(timeRange, selectedTable);
//     }, [timeRange, setLoading, baseUrl, selectedTable]);

//     const currentYear = new Date().getFullYear();
//     const generateMonthOptions = (year) => {
//         const months = [
//             'January', 'February', 'March', 'April', 'May', 'June',
//             'July', 'August', 'September', 'October', 'November', 'December'
//         ];
//         return months.map((month, index) => {
//             const monthValue = `${year}-${(index + 1).toString().padStart(2, '0')}`;
//             return <option key={monthValue} value={monthValue}>{`${month} ${year}`}</option>;
//         });
//     };

//     const fetchManifestData = (timeRange, selectedTable) => {
//         setLoading(true); // Start loading
//         axios.get(`${baseUrl}/api/gl-data/`, { params: { time_range: timeRange, table: selectedTable } })
//             .then(response => {
//                 setManifestItems(response.data['gl-data']);
//                 setLoading(false); // End loading
//             })
//             .catch(error => {
//                 console.error('There was an error fetching the manifest data!', error);
//                 setLoading(false); // End loading even on error
//             });
//     };

//     const handleTimeRangeChange = (event) => {
//         setTimeRange(event.target.value);
//     };
//     const handleTableChange = (event) => {
//         setSelectedTable(event.target.value);
//     };

//     const filterItems = (items) => {
//         if (!items) return [];
//         return items.filter(item =>
//             (item.max_monthly_volume_unsellable || 0) > 0 ||
//             (item.max_monthly_volume_sellable || 0) > 0
//         );
//     };

//     const itemColumns = [
//         { headerName: "GL Number", field: "gl_number" },
//         { headerName: "Category", field: "category" },
//         { headerName: "Sub-categories", field: "sub_categories" },
//         {
//             headerName: "Total Monthly Volume",
//             valueGetter: (params) =>
//                 (params.data.max_monthly_volume_unsellable || 0) +
//                 (params.data.max_monthly_volume_sellable || 0),
//             sortable: true
//         },
//         {
//             headerName: "Max Monthly Volume Unsellable",
//             field: "max_monthly_volume_unsellable",
//         },
//         {
//             headerName: "Max Monthly Volume Sellable",
//             field: "max_monthly_volume_sellable",
//         },
//     ];

//     const manifestColumns = [
//         { headerName: "GL Number", field: "GL" },
//         { headerName: "GL Description", field: "GLDesc" },
//         { headerName: "Total Units", field: "total_units" },
//     ];

//     const recoveryRateColumns = [
//         { headerName: "GL Number", field: "gl_number" },
//         { headerName: "Category", field: "category" },
//         { headerName: "Average Selling Price per Unit", field: "average_selling_price_per_unit" },
//         {
//             headerName: "Your Rate Unsellable (%)",
//             field: "your_rate_unsellable",
//             valueFormatter: (params) => {
//                 const value = params.value * 100;
//                 return value.toFixed(2) + '%';
//             }
//         },
//         {
//             headerName: "Your Rate Sellable (%)",
//             field: "your_rate_sellable",
//             valueFormatter: (params) => {
//                 const value = params.value * 100;
//                 return value.toFixed(2) + '%';
//             }
//         },
//     ];

//     const statusBar = useMemo(() => ({
//         statusPanels: [
//           { statusPanel: 'agTotalRowCountComponent', align: 'left', key: 'totalRowComponent' },
//           { statusPanel: 'agAggregationComponent', align: 'right' },
//         ],
//       }), []);

//     return (
//         <div className='biddingsheet-body'>
//             {isLoading && <LoadingIndicator />} {/* Show loading indicator */}
//             {!isLoading && biddingSheet && (
//                 <div key={biddingSheet.id}>
//                     <h2 style={{padding:'20px', backgroundColor:'rgba(204, 255, 224)'}}>Bidding Sheet: {biddingSheet.identifier}</h2>

//                     <div style={{ display: 'flex', gap: '10px'}}>
//                         {/* Ag-Grid for BiddingSheetItem */}
//                         <div style={{ flex: 1.4 ,  marginLeft: '20px' }}>
//                             <h3 style={{ textAlign:'center', marginBottom:'15px'}}>Bidding Sheet Volume</h3>
//                             <div className="ag-theme-alpine" style={{ width: '100%' }}>
//                                 <AgGridReact
//                                     rowData={filterItems(biddingSheet.items).sort((a, b) => a.gl_number - b.gl_number)}  // Sort items by GL Number
//                                     columnDefs={itemColumns}
//                                     pagination={true}
//                                     domLayout='autoHeight'
//                                     enableRangeSelection={true}
//                                     statusBar={statusBar}
//                                 />
//                             </div>
//                         </div>

//                         {/* Ag-Grid for Manifest Items */}
//                         <div style={{ flex: 1, marginRight: '20px' }}>
//                             <div style={{ display: 'flex',marginBottom: '10px', alignItems: 'center', justifyContent: 'center', textAlign: 'center', gap: '20px' }}>
//                                 <h3 style={{ textAlign:'center'}}>{selectedTable}</h3>
//                                 {/* Dropdown for time range selection */}
//                                 <select className='source-dropdown' value={timeRange} onChange={handleTimeRangeChange}>
//                                     <option value="current_month">Current Month</option>
//                                     <option value="all_time">All Time</option>
//                                     {generateMonthOptions(currentYear)}
//                                     {/* Add more months dynamically if needed */}
//                                 </select>
//                                 <select className='source-dropdown' value={selectedTable} onChange={handleTableChange}>
//                                 <option value="Manifest">Manifest Items</option>
//                                 <option value="ReceivedItems">Received Items</option>
//                                 <option value="MissingItems">Missing Items</option>
//                                     {/* Add more months dynamically if needed */}
//                                 </select>
//                             </div>
//                             <div className="ag-theme-alpine" style={{ width: '100%' }}>
//                                 <AgGridReact
//                                     rowData={manifestItems}
//                                     columnDefs={manifestColumns}
//                                     pagination={true}
//                                     domLayout='autoHeight'
//                                     enableRangeSelection={true}
//                                     statusBar={statusBar}
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Ag-Grid for BiddingSheetRecoveryRate */}
//                     <div style={{ margin:'20px'}}>
//                     <h3 style={{ textAlign:'center', marginBottom:'10px'}}>Bidding Sheet Recovery Rates</h3>
//                     <div className="ag-theme-alpine" style={{ width: '100%'}}>
//                         <AgGridReact
//                             rowData={biddingSheet.recovery_rates}
//                             columnDefs={recoveryRateColumns}
//                             pagination={true}
//                             domLayout='autoHeight'
//                             enableRangeSelection={true}
//                             statusBar={statusBar}
//                         />
//                     </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default BiddingSheet;

import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import DatePicker from "react-datepicker";
import { CalendarDays, RotateCcw } from "lucide-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "react-datepicker/dist/react-datepicker.css";
import { useLoading } from "../utils/loading/LoadingContext"; // Adjust path as necessary
import "./styles/modern-pages.css";
import "./styles/biddingsheet.css";

const BiddingSheet = () => {
  const [biddingSheet, setBiddingSheet] = useState(null);
  const [manifestItems, setManifestItems] = useState([]);
  const [timeRange, setTimeRange] = useState("current_month"); // Default to current month
  const [startDate, setStartDate] = useState(null); // For custom range start date
  const [endDate, setEndDate] = useState(null); // For custom range end date
  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
  const [selectedTable, setSelectedTable] = useState("Manifest");
  const { isLoading, setLoading } = useLoading();
  const formatApiDate = (date) => {
    // Adjust for timezone offset to ensure the correct date is sent
    const adjustedDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    return adjustedDate.toISOString().split("T")[0];
  };

  useEffect(() => {
    setLoading(true);

    // Fetch all bidding sheets and select the latest one based on identifier
    axios
      .get(`${baseUrl}/api/bidding-sheets/?table=${selectedTable}`)
      .then((response) => {
        const allBiddingSheets = response.data;

        allBiddingSheets.sort((a, b) => {
          return b.identifier.localeCompare(a.identifier, undefined, {
            numeric: true,
          });
        });

        if (allBiddingSheets.length > 0) {
          setBiddingSheet(allBiddingSheets[0]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the bidding sheets data!",
          error
        );
        setLoading(false);
      });

    fetchManifestData();
  }, [timeRange, setLoading, baseUrl, selectedTable, startDate, endDate]);

  const fetchManifestData = () => {
    setLoading(true);
    const params = { time_range: timeRange, table: selectedTable };

    if (timeRange === "custom" && startDate && endDate) {
      params.start_date = startDate ? formatApiDate(startDate) : null;
      params.end_date = endDate ? formatApiDate(endDate) : null;
    }

    axios
      .get(`${baseUrl}/api/gl-data/`, { params })
      .then((response) => {
        setManifestItems(response.data["gl-data"]);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the manifest data!", error);
        setLoading(false);
      });
  };

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
  };

  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const handleTableChange = (event) => {
    setSelectedTable(event.target.value);
  };

  const filterItems = (items) => {
    if (!items) return [];
    return items.filter(
      (item) =>
        (item.max_monthly_volume_unsellable || 0) > 0 ||
        (item.max_monthly_volume_sellable || 0) > 0
    );
  };

  const itemColumns = [
    { headerName: "GL Number", field: "gl_number" },
    { headerName: "Category", field: "category" },
    { headerName: "Sub-categories", field: "sub_categories" },
    {
      headerName: "Total Monthly Volume",
      valueGetter: (params) =>
        (params.data.max_monthly_volume_unsellable || 0) +
        (params.data.max_monthly_volume_sellable || 0),
      sortable: true,
    },
    {
      headerName: "Max Monthly Volume Unsellable",
      field: "max_monthly_volume_unsellable",
    },
    {
      headerName: "Max Monthly Volume Sellable",
      field: "max_monthly_volume_sellable",
    },
  ];

  const manifestColumns = [
    { headerName: "GL Number", field: "GL" },
    { headerName: "GL Description", field: "GLDesc" },
    { headerName: "Total Units", field: "total_units" },
  ];

  const recoveryRateColumns = [
    { headerName: "GL Number", field: "gl_number" },
    { headerName: "Category", field: "category" },
    {
      headerName: "Average Selling Price per Unit",
      field: "average_selling_price_per_unit",
    },
    {
      headerName: "Your Rate Unsellable (%)",
      field: "your_rate_unsellable",
      valueFormatter: (params) => {
        const value = params.value * 100;
        return value.toFixed(2) + "%";
      },
    },
    {
      headerName: "Your Rate Sellable (%)",
      field: "your_rate_sellable",
      valueFormatter: (params) => {
        const value = params.value * 100;
        return value.toFixed(2) + "%";
      },
    },
  ];

  const statusBar = useMemo(
    () => ({
      statusPanels: [
        {
          statusPanel: "agTotalRowCountComponent",
          align: "left",
          key: "totalRowComponent",
        },
        { statusPanel: "agAggregationComponent", align: "right" },
      ],
    }),
    []
  );

  return (
    <div className="modern-page biddingsheet-body">
      <div className="modern-page-shell">
        <header className="modern-page-header bidding-header">
          <div className="bidding-title-group">
            <h1 className="modern-page-title">Bidding Sheet</h1>
            {biddingSheet && (
              <span className="modern-page-meta">
                {biddingSheet.identifier} · {new Date(biddingSheet.effective_date).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            )}
          </div>

          <div className="bidding-filters" aria-label="Bidding sheet filters">
            <label>
              <span>Period</span>
              <select value={timeRange} onChange={handleTimeRangeChange}>
                <option value="current_month">Current Month</option>
                <option value="all_time">All Time</option>
                <option value="custom">Custom Range</option>
              </select>
            </label>

            {timeRange === "custom" && (
              <>
                <label className="bidding-date-field">
                  <span>From</span>
                  <div><CalendarDays size={16} />
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      maxDate={endDate}
                      placeholderText="Start date"
                      dateFormat="dd MMM yyyy"
                    />
                  </div>
                </label>
                <label className="bidding-date-field">
                  <span>To</span>
                  <div><CalendarDays size={16} />
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      placeholderText="End date"
                      dateFormat="dd MMM yyyy"
                    />
                  </div>
                </label>
                <button
                  type="button"
                  className="bidding-clear"
                  onClick={handleClearDates}
                  disabled={!startDate && !endDate}
                  aria-label="Clear dates"
                >
                  <RotateCcw size={16} />
                </button>
              </>
            )}

            <label>
              <span>Source</span>
              <select value={selectedTable} onChange={handleTableChange}>
                <option value="Manifest">Manifest Items</option>
                <option value="ReceivedItems">Received Items</option>
                <option value="MissingItems">Missing Items</option>
              </select>
            </label>
          </div>
        </header>

        {!isLoading && biddingSheet ? (
          <div className="bidding-content" key={biddingSheet.id}>
            <section className="modern-panel bidding-volume-panel">
              <div className="modern-panel-header"><h2>Bidding Sheet Volume</h2></div>
              <div className="ag-theme-alpine bidding-grid">
                <AgGridReact
                  rowData={filterItems(biddingSheet.items).sort(
                    (a, b) => a.gl_number - b.gl_number
                  )}
                  columnDefs={itemColumns}
                  pagination={true}
                  domLayout="autoHeight"
                  enableRangeSelection={true}
                  statusBar={statusBar}
                />
              </div>
            </section>

            <section className="modern-panel bidding-source-panel">
              <div className="modern-panel-header">
                <h2>{selectedTable === "Manifest" ? "Manifest" : selectedTable === "ReceivedItems" ? "Received" : "Missing"}</h2>
                <span className="modern-page-meta">{manifestItems.length} rows</span>
              </div>
              <div className="ag-theme-alpine bidding-grid">
                <AgGridReact
                  rowData={manifestItems}
                  columnDefs={manifestColumns}
                  pagination={true}
                  domLayout="autoHeight"
                  enableRangeSelection={true}
                  statusBar={statusBar}
                />
              </div>
            </section>

            <section className="modern-panel bidding-recovery-panel">
              <div className="modern-panel-header"><h2>Bidding Sheet Recovery Rates</h2></div>
              <div className="ag-theme-alpine bidding-grid">
              <AgGridReact
                rowData={biddingSheet.recovery_rates}
                columnDefs={recoveryRateColumns}
                pagination={true}
                domLayout="autoHeight"
                enableRangeSelection={true}
                statusBar={statusBar}
              />
            </div>
            </section>
          </div>
        ) : !isLoading ? (
          <div className="modern-panel modern-empty-state">No bidding sheet available.</div>
        ) : null}
      </div>
    </div>
  );
};

export default BiddingSheet;
